import { find } from 'lodash';
import { getFirstBarber } from '../register/order/selectors';
import {
  ADD_BARBER,
  REMOVE_BARBER,
  RESET,
} from '../register/order/constants';
import {
  isEmpty,
  setActiveBarber,
} from '../register/sale/actions';
import { resetPromoCode } from '../register/promo/actions';
import * as customerActions from '../register/customer/constants';
import { ERROR } from '../register/validated/constants';
import { fetchPaymentCard } from '../main/payment/actions';
import {
  setFetching,
} from '../register/payment/reducer/isFetching/actions';
import { setCard, resetCustomer } from '../register/customer/actions';
import { closePayment } from '../register/payment/reducer/currentPayment/actions';
import { resetPayments } from '../register/payment/actions';

const saleMiddleware = store => next => (action) => {
  next(action);

  const setPaymentCard = () => {
    const customerId = action.payload.id || action.payload.objectID;
    if (!customerId) return;

    const setSaleCard = (response) => {
      const customPaymentCard = find(response, { id: action.customPaymentCardId });
      const defaultCard = find(response, { isDefault: true });
      const card = customPaymentCard || defaultCard;

      if (!card) return Promise.resolve();
      store.dispatch(setCard({ ...card.details, id: card.id }));
      return Promise.resolve();
    };
    const disableFetching = () => store.dispatch(setFetching(false));

    store.dispatch(closePayment());
    store.dispatch(setFetching(true));
    store.dispatch(fetchPaymentCard(customerId))
      .then(setSaleCard)
      .then(disableFetching)
      .catch(disableFetching);
  };

  switch (action.type) {
    case ADD_BARBER:
      store.dispatch(setActiveBarber(action.payload));
      break;

    case REMOVE_BARBER: {
      const firstBarber = getFirstBarber(store.getState());
      if (!firstBarber) {
        store.dispatch(isEmpty());
      }
      store.dispatch(setActiveBarber(firstBarber));
      break;
    }

    case customerActions.RESET:
    case ERROR:
      store.dispatch(resetPromoCode());
      store.dispatch(setCard());
      store.dispatch(closePayment());
      break;

    case customerActions.SET:
      setPaymentCard();
      break;

    case RESET:
      store.dispatch(resetCustomer());
      store.dispatch(resetPayments());
      break;
    default:
  }
};

export default saleMiddleware;
